import classnames from 'classnames';
import pick from 'lodash/fp/pick';
import React, { useState } from 'react';
import { Badge, Button, Card } from 'react-bootstrap';
import Truncate from 'react-truncate';
import IconButton from 'v2/common/IconButton/IconButton';
import { DataProductEntity, DataProductFormData } from 'v2/DataProducts/models';
import editIcon from 'v2/icons/edit-rectangle.svg';
import trashCanIcon from 'v2/icons/trash-outlined.svg';
import {
  DATA_PRODUCT_DEFAULT_VALUES,
  getSortedDataProductBadgeData,
  parseDataTagsToEdit,
} from 'v2/utils/dataProducts';
import { formatTextNewlines } from 'v2/utils/textFormat';
import styles from './dataProductItemV2.module.scss';

interface DataProductItemV2Props {
  data: DataProductEntity;
  isAdmin: boolean;
  onEdit: (data: DataProductFormData) => void;
  onDelete: (data: DataProductEntity) => void;
}

const DataProductItemV2 = ({
  data,
  isAdmin,
  onEdit,
  onDelete,
}: DataProductItemV2Props) => {
  const [viewMore, setViewMore] = useState(false);
  const [truncated, setTruncated] = useState(false);
  const productDataBages = getSortedDataProductBadgeData(data);

  const handleTruncate = (_truncated: boolean) => {
    if (_truncated && _truncated !== truncated) {
      setTruncated(_truncated);
    }
  };

  const _onEdit = () => {
    onEdit({
      id: data.id,
      ...pick(Object.keys(DATA_PRODUCT_DEFAULT_VALUES))(data),
      ...parseDataTagsToEdit(data.data_tags),
    } as DataProductFormData);
  };

  return (
    <Card className="border-light5 mb-5">
      <Card.Header
        className={classnames(
          'd-flex align-items-cener justify-content-between',
          'bg-transparent border-0'
        )}
      >
        <p className="p-0 m-0 text-primary-dark">{data.name}</p>
        {isAdmin ? (
          <div className="d-flex">
            <IconButton className="mr-3" onClick={_onEdit} icon={editIcon} />
            <IconButton onClick={() => onDelete(data)} icon={trashCanIcon} />
          </div>
        ) : null}
      </Card.Header>
      <Card.Body className={styles.cardBody}>
        <p className={'scroll text-light4'}>
          <Truncate lines={!viewMore && 3} onTruncate={handleTruncate}>
            {formatTextNewlines(data.description)}
          </Truncate>
        </p>
        <div>
          {truncated ? (
            <Button
              className="p-0"
              variant="link"
              onClick={() => setViewMore(!viewMore)}
            >
              {viewMore ? 'Show less' : 'Show more'}
            </Button>
          ) : null}
        </div>

        <div
          className={classnames(
            'pt-3 pb-1 custom-scroll',
            styles.carouselContainer
          )}
        >
          {productDataBages.map((item) =>
            item.data ? (
              <div key={item.label} className="mb-2 d-inline">
                <Badge
                  pill
                  variant="primary-light"
                  className="text-primary py-2 px-3 mr-2"
                >
                  <span className={classnames(styles.subtitle)}>
                    {item.label}:{' '}
                  </span>
                  <span className="font-weight-light">{item.data}</span>
                </Badge>
              </div>
            ) : null
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default DataProductItemV2;
